import { Popconfirm, Table, Input, message, Pagination } from "antd";
import React, { useEffect, useState } from "react";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import "animate.css";
import {
  ExtractDate,
  ExtractTime,
  messageConfiguration,
} from "../../../../utils";
import ComponentTitle from "../../../../Common/ComponentTitle";
import { deleteBodyType, getBodyTypeDetails } from "./BodytypeApi";
import AddBodyType from "./AddBodyType";
const BodyTypeDetails = () => {
  const [bodyTypeData, setBodytypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [from, setFrom] = useState("category");
  const [filldata, setFilldata] = useState({});
  const [action, setAction] = useState("");
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  const pageSize = 10;
  function FetchBodytypeDetails(currentPage) {
    setIsLoading(true);
    getBodyTypeDetails(`?search=${searchTerm}&page=${currentPage}&limit=10`)
      .then((response) => {
        if (response.data.status) {
          setBodytypeData(response.data?.data);
          setCurrentPage(response.data?.pagination?.currentPage);
          setTotalPages(response.data?.pagination?.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }
  function DeleteAction(checked, record) {
    deleteBodyType(`${record.id}`)
      .then((response) => {
        if (response.data.status) {
          message.open(
            messageConfiguration("success", response.data.message, 3)
          );
          FetchBodytypeDetails(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    FetchBodytypeDetails(currentPage);
  }, [currentPage, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  const setwithdrawAction = (id, value) => {
    setAction((prevAction) => ({
      ...prevAction,
      [id]: value,
    }));
  };

  const columns = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },
    {
      title: "Body Type Name",
      dataIndex: "name",
      key: "name",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record.name?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Created Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt ?? "--")}.
              {ExtractTime(record.createdAt ?? "--")}
            </p>
          </>
        );
      },
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <EditOutlined
              className="text-xs font-poppins"
              onClick={() => {
                setOpenModal(true);
                setFrom("edit");
                setFilldata(record);
              }}
            />
          </>
        );
      },
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Popconfirm
          title={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Are you sure you want to delete this Body Type?
              </p>
            </div>
          }
          onConfirm={() => DeleteAction(undefined, record)}
          okText="Delete"
          cancelText="Cancel"
        >
          <DeleteOutlined className="text-xs font-poppins" title="Delete" />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <ComponentTitle title={"Body Type List"} />
      <div className="flex items-end justify-between mb-4">
        <Search
          placeholder="search  here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        />
        <p
          onClick={() => {
            setOpenModal(true);
            setFrom("add");
          }}
          className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary5"
        >
          Create Body Type
        </p>
      </div>

      <div
        style={{ maxHeight: "500px", overflow: "auto" }}
        className="bg-white "
      >
        <Table
          bordered={true}
          columns={columns}
          loading={isLoading}
          dataSource={bodyTypeData}
          pagination={false}
          className="w-screen sm:w-screen custom-table-header"
          size="small"
        />
      </div>
      <Pagination
        className="mt-2  w-full flex justify-center items-center "
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        total={10 * totalPage}
        showSizeChanger={false}
        pageSize={pageSize}
      />
      {openModal && (
        <AddBodyType
          isOpen={openModal}
          setIsOpen={setOpenModal}
          Fill={filldata}
          setFill={setFilldata}
          from={from}
          current={currentPage}
          apiCall={FetchBodytypeDetails}
        />
      )}
    </div>
  );
};
export default BodyTypeDetails;
